import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppStoreBadgeEs, LazyAppStoreBadgePt, LazyEscapadaLogoSmall, LazyGooglePlayBadgeEs, LazyGooglePlayBadgePt, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AppStoreBadgeEs", LazyAppStoreBadgeEs],
["AppStoreBadgePt", LazyAppStoreBadgePt],
["EscapadaLogoSmall", LazyEscapadaLogoSmall],
["GooglePlayBadgeEs", LazyGooglePlayBadgeEs],
["GooglePlayBadgePt", LazyGooglePlayBadgePt],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
